import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { IndustryCard, LoadingBlock } from "@/components/site/Cards";

export default function Industries() {
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/industries").then((r) => setIndustries(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="industries-page">
      <section className="border-b border-oc-hairline">
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16 md:py-24">
          <div className="eyebrow text-oc-coral mb-6">Discover by Industry</div>
          <h1 className="hero-headline text-5xl md:text-7xl text-oc-ink">Industries</h1>
          <p className="mt-6 font-editorial text-xl text-oc-ink-soft max-w-2xl">
            Enter through familiarity. Each industry hub connects operating conversations, common challenges, and the operators who navigate them.
          </p>
        </div>
      </section>
      <section>
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16">
          {loading ? (
            <LoadingBlock />
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {industries.map((i) => <IndustryCard key={i.slug} industry={i} />)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
